import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DataUtils } from 'ng-jhipster';

import { ImageResource } from './image-resource.model';
import { ImageResourcePopupService } from './image-resource-popup.service';
import { ImageResourceService } from './image-resource.service';
@Component({
    selector: 'dcs-image-resource-dialog',
    templateUrl: './image-resource-dialog.component.html'
})
export class ImageResourceDialogComponent implements OnInit {

    imageResource: ImageResource;
    authorities: any[];
    isSaving: boolean;
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private dataUtils: DataUtils,
        private alertService: AlertService,
        private imageResourceService: ImageResourceService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['imageResource']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }
    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }

    setFileData($event, imageResource, field, isImage) {
        if ($event.target.files && $event.target.files[0]) {
            let $file = $event.target.files[0];
            if (isImage && !/^image\//.test($file.type)) {
                return;
            }
            this.dataUtils.toBase64($file, (base64Data) => {
                imageResource[field] = base64Data;
                imageResource[`${field}ContentType`] = $file.type;
            });
        }
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.imageResource.id !== undefined) {
            this.imageResourceService.update(this.imageResource)
                .subscribe((res: ImageResource) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.imageResourceService.create(this.imageResource)
                .subscribe((res: ImageResource) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: ImageResource) {
        this.eventManager.broadcast({ name: 'imageResourceListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'dcs-image-resource-popup',
    template: ''
})
export class ImageResourcePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private imageResourcePopupService: ImageResourcePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.imageResourcePopupService
                    .open(ImageResourceDialogComponent, params['id']);
            } else {
                this.modalRef = this.imageResourcePopupService
                    .open(ImageResourceDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource-dialog.component.ts